

function getSelectOptions() {
    return {
        materialInch: [{
            name: 'Mild Steel 44 ksi',
            value: 'DC04',
        }, {
            name: 'High strength steel 62.1 ksi',
            value: 'HX260YD',
        }, {
            name: 'Dual phase steel 95.7 ksi',
            value: 'HCT590X',
        }, {
            name: 'Stainless steel  105  ksi',
            value: '14301',
        }, {
            name: 'Aluminium 1050_O  11.8 ksi',
            value: '1050_O',
        }, {
            name: 'Aluminium 5754_O 33 ksi',
            value: '5754_O',
        }, {
            name: 'Aluminium 6016_T4P  35 ksi',
            value: '6016_T4P',
        }],
        materialMm: [{
          name: 'Mild Steel 303.5 MPa ',
          value: 'DC04',
        }, {
          name: 'High strength steel 428.3 MPa',
          value: 'HX260YD',
        }, {
          name: 'Dual phase steel 659.8   MPa',
          value: 'HCT590X',
        }, {
          name: 'Stainless steel 723.7 MPa',
          value: '14301',
        }, {
          name: 'Aluminium 1050_O 81.6 MPa',
          value: '1050_O',
        }, {
          name: 'Aluminium 5754_O 227.2 MPa',
          value: '5754_O',
        }, {
          name: 'Aluminium 6016_T4P 241.4 MPa',
          value: '6016_T4P',
        }],
        offset: [{
            name: 'mid surface of part',
            value: '0',
        }, {
            name: 'lower surface of part',
            value: '-1',
        }, {
            name: 'upper surface of part',
            value: '1',
        }],
        unit: [{
            name: 'Metric',
            value: 'metric',
        }, {
            name: 'PSI',
            value: 'psi',
        }],
        holdingCond: [{
              name: 'Crash form',
              value: '0.0',
        }, {
              name: 'Deep draw',
              value: '0.3',
        }, {
            name: 'Stretch form',
            value: '1.0',
        }],
        results: [{
            name: 'Thinning',
            letter: 'T',
            value: 'thinning',
        }, {
            name: 'Formability',
            letter: 'G',
            value: 'feasibility',
        }],
        priceUnit: [{
            name: '$/ton',
            value: '$',
        }, {
            name: '€/ton',
            value: '€',
        }, {
            name: '£/ton',
            value: '£',
        }, {
            name: '¥/ton',
            value: '¥',
        }],
        nType: [{
            name: 'OneUp',
            value: '0',
        }, {
            name: 'TwoUp',
            value: '1',
        }, {
            name: 'UpDown',
            value: '2',
        }],
        _orientType: [{
            name: 'Free',
            value: '0',
        }, {
            name: 'Angle',
            value: '1',
        }], selectedReportView: [{
            name: 'Formability',
            value: 'feasibility',
        }, {
            name: 'Thinning',
            value: 'thinning',
        }, {
            name: 'Blank',
            value: 'blank',
        }, {
            name: 'Nest',
            value: 'nest',
        }],
    };
}

export default getSelectOptions;



// WEBPACK FOOTER //
// ./client/app/common/services/select-options.js